export default "__VITE_ASSET__Bbma$JwY__"